import React from 'react'
import { useSelector } from 'react-redux'
import { match, useRouteMatch } from 'react-router-dom'

import { ReactComponent as ChatsIcon } from '@app/assets/Small/Outline/Chats.svg'
import { ReactComponent as InvoiceIcon } from '@app/assets/Small/Outline/Invoice.svg'
import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { useIntl } from '@app/intl/Intl'
import { PageTabs } from '@app/lib/layout/PageTabs/PageTabs'
import { CourtCaseTabNames, getCourtCasePath } from '@app/modules/CourtCases/paths'

export type ServiceTaskTabsProps = {
  selected: CourtCaseTabNames
}

export const CourtCaseTabs = ({ selected }: ServiceTaskTabsProps) => {
  const { formatMessage } = useIntl()
  const match: match<{ id: string; courtCaseUuid: string }> = useRouteMatch()
  const customerId = Number(match.params.id)
  const courtCaseUuid = match.params.courtCaseUuid

  return (
    <PageTabs
      tabs={[
        {
          enabled: true,
          link: getCourtCasePath(customerId, courtCaseUuid, CourtCaseTabNames.ChatChronic),
          label: formatMessage({ id: 'CourtCases.Menu.Item.ChatChronic' }),
          isSelected: selected === CourtCaseTabNames.ChatChronic,
          icon: <ChatsIcon />
        },
        {
          enabled: useSelector(isFeatureEnabled(Features.COURT_CASE_INVOICING)),
          link: getCourtCasePath(customerId, courtCaseUuid, CourtCaseTabNames.Invoicing),
          label: formatMessage({ id: 'CourtCases.Menu.Item.Invoicing' }),
          isSelected: selected === CourtCaseTabNames.Invoicing,
          icon: <InvoiceIcon />
        }
      ].filter((method) => method.enabled)}
    />
  )
}
